import { useState, useEffect, useCallback } from 'react'
import { RequestService } from '../services/RequestService'
import { useSnackbar } from '../hooks'

const useIntakeList = ({ page, userId }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const { successSnackbar, errorSnackbar } = useSnackbar()

  const fetchData = useCallback(async () => {
    setLoading(true)
    setData(null)

    try {
      const { data } = await RequestService.getIntakeList({ userId })
      setData(data)
    } catch (e) {
      console.log('useIntakeList fetchData', e)
    }

    setLoading(false)
  }, [userId, page])

  const deleteIntake = useCallback(
    async (type, id) => {
      try {
        const response = await RequestService.deleteIntake({ type, id })

        if (response?.status === RequestService.STATUSES.SUCCESS) {
          successSnackbar({ text: 'Registro excluído com sucesso!' })
          await fetchData()
        } else {
          errorSnackbar({
            text: response?.data?.message || 'Erro ao excluir registro!',
          })
        }
      } catch (e) {
        console.error('deleteIntake error:', e)
        errorSnackbar({ text: e?.data?.message || 'Erro ao excluir registro!' })
      }
    },
    [fetchData, successSnackbar, errorSnackbar]
  )

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return { data, loading, deleteIntake }
}


export default useIntakeList
